export const APP_VERSION = '2.5.9';
export const APP_BUILD_DATE = '26 Octombrie 2026';
export const APP_BUILD_TAG = 'Master Lock Înregistrare Automată Multi-Admin, Selector Zoom Mod Afișare (Grilă, Vorbitor, Studio 16:9 Paginat), Paginare Video Grid';

